import React from 'react';
import styled from 'styled-components';
import Loadable from 'react-loadable';

function Loading() {
  return <h3>Loading...</h3>;
}

const AddIntegration = Loadable({
  loader: () => import('../AddIntegration'),
  loading: Loading,
});

const AddIntegrationContainer = () => (
    <AddIntegration />
)

AddIntegrationContainer.propTypes = {
};

export default AddIntegrationContainer;
